export const compareDates = (date1, date2) => {
  const d1 = new Date(date1);
  const d2 = new Date(date2);

  const dateOnly1 = new Date(d1.getFullYear(), d1.getMonth(), d1.getDate());
  const dateOnly2 = new Date(d2.getFullYear(), d2.getMonth(), d2.getDate());

  return dateOnly1.getTime() === dateOnly2.getTime();
};

export const formatUnixDate = (unixDate, time = false) => {
  const date = new Date(unixDate * 1000);

  const options = {
    month: 'long',
    day: 'numeric',
    year: 'numeric',
  };

  const formatter = new Intl.DateTimeFormat(
    'en-US',
    time ? { ...options, hour: 'numeric', minute: '2-digit', hour12: true } : options,
  );
  return formatter.format(date);
};

export const formatNumberWithCommas = (number) => number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');

export const checkPostalCode = (postalCode) => {
  const regex = /^([A-Za-z][0-9]){3}$/;
  return regex.test(postalCode.trim());
};

export const maskEmail = (email) => {
  if (!email) return '';
  const [local, domain] = email.split('@');
  const maskedLocal = local.length <= 2 ? `${local[0]}****` : `${local.slice(0, 2)}****`;
  return domain ? `${maskedLocal}@${domain}` : maskedLocal;
};

export const maskPhone = (phone) => {
  if (!phone) return '';
  const digits = phone.replace(/\D/g, '');
  if (digits.length < 6) return phone;

  const first = digits.slice(0, 2);
  const last = digits.slice(-4);
  return `+${first}****${last}`;
};

export const formatWinInfo = (winPercentage, winner, second) => {
  if (!winner) return 'No data';

  if (winPercentage && winner && second) {
    return `${winner} beats ${second} by ${winPercentage}%`;
  }

  return `${winner} win`;
};

export const checkForEmptyString = (string) => string || '-';
